import React, { FC, useMemo } from 'react';
import Button from '../core/Button';
import { defineMessages, FormattedMessage, useIntl } from 'react-intl';
import { useSearchParams } from 'react-router-dom';

interface LoginFailedScreenProps {
  onConfirm: () => void;
}

const messages = defineMessages({
  not_part_of_org: {
    id: 'login_failed_not_part_of_org',
    defaultMessage: 'You are not part of the selected organization.',
  },
  too_many_attempts: {
    id: 'login_failed_too_many_attempts',
    defaultMessage: 'Too many login attempts.',
  },
  password_leaked: {
    id: 'login_failed_password_leaked',
    defaultMessage:
      'Your password has been leaked. Please reset your password by clicking ”Forgot password?” on the login screen.',
  },
  unauthorized: {
    id: 'login_failed_unauthorized',
    defaultMessage:
      'Your account is not available. Contact support at support@allbinary.se.',
  },
});

const LoginFailedScreen: FC<LoginFailedScreenProps> = ({ onConfirm }) => {
  const intl = useIntl();
  const [params] = useSearchParams();
  const errorDescription = useMemo(() => {
    const err = params.get('error');
    const error_description = params.get('error_description');
    if (error_description?.includes('not part of the')) {
      return intl.formatMessage(messages.not_part_of_org);
    }
    switch (err) {
      case 'too_many_attempts':
        return intl.formatMessage(messages.too_many_attempts);
      case 'password_leaked':
        return intl.formatMessage(messages.password_leaked);
      case 'unauthorized':
        return intl.formatMessage(messages.unauthorized);
      default:
        return '';
    }
  }, [intl, params]);

  return (
    <div className="flex h-full items-center justify-center bg-white">
      <div className="flex w-[520px] flex-col items-center gap-3">
        <div>
          <img src={'/hållkoll.png'} alt="HållKoll Logo" width={500} />
        </div>
        <h3 className="w-full text-left text-red-500">
          <FormattedMessage
            id="login_failed_header"
            defaultMessage="Login failed"
          />
        </h3>
        {errorDescription && (
          <p className="w-full text-left text-base leading-6 text-red-500">
            {errorDescription}
          </p>
        )}
        <p className="w-full text-left text-base leading-6 text-red-500">
          <FormattedMessage
            id="login_failed_instructions"
            defaultMessage="Click to login again."
          />
        </p>
        <div className="mt-4 flex w-[400px] flex-col gap-3">
          <Button variant="filled" className="w-full" onClick={onConfirm}>
            <FormattedMessage id="ok" defaultMessage="Ok" />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default LoginFailedScreen;
